import type { ReactElement } from "react";
import { Datagrid, NumberField, TextField, useListContext } from "react-admin";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { useNavigate } from "react-router";
import { MoneyField } from "../../fields/MoneyField";
import { Column } from "../../misc/Column";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import type { DrivingSchoolServiceType } from "../../providers/drivingSchoolServiceTypesProvider";
import { ServiceTypeMobileListItem } from "./ServiceTypeMobileListItem";

export function ServiceTypesDataGrid(props: { empty?: ReactElement }) {
  const { empty } = props;
  const { isLoading, data, total } = useListContext<DrivingSchoolServiceType>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isMobile) {
    if (!data || data.length === 0 || total === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((serviceType) => (
          <ServiceTypeMobileListItem
            key={serviceType.id}
            serviceType={serviceType}
            onClick={() => navigate(`/serviceTypes/${serviceType.id}`)}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid rowClick="edit" bulkActionButtons={false} empty={empty}>
      <TextField label="Titel" source="title" />
      <NumberField label="MwSt." source="vatRate" options={{ style: "unit", unit: "percent" }} />
      <MoneyField label="Standard Preis" source="price" />
    </Datagrid>
  );
}
